import axios, {AxiosRequestConfig} from 'axios'

import {CoinListModel, SetupModelPaginated} from './_types'
import {apiURL} from '_metronic/helpers'

const API_URL = process.env.REACT_APP_API_URL
const MOCK_AUTH = process.env.REACT_APP_MOCK_AUTH === 'true' || !API_URL

const MOCK_TRADER = {
  name: 'demouser',
  image: null,
  twitter: null,
  id: 'mock-user-id',
  rate: 74,
  weekly_r: 2.5,
  monthly_r: 8.1,
  followers: 312,
  is_following: false,
}

const MOCK_SETUPS_SEED: SetupModelPaginated['data'] = [
  {
    id: 'setup-1',
    category: 'futures',
    status: 'active',
    coin_name: 'BTCUSDT',
    coin_icon: 'https://assets.coingecko.com/coins/images/1/thumb/bitcoin.png',
    order_type: 'limit',
    position: 'long',
    duration: 'short',
    r_value: 1,
    entry_value: 84200,
    stop_value: 82000,
    profit_taking_1: 87000,
    profit_taking_amount_1: 50,
    profit_taking_2: 90000,
    profit_taking_amount_2: 30,
    profit_taking_3: 95000,
    profit_taking_amount_3: 20,
    is_tp1: true,
    is_tp2: false,
    is_tp3: false,
    tp1_date: new Date('2026-03-20T10:30:00'),
    tp2_date: null,
    tp3_date: null,
    close_price: null,
    close_date: null,
    image: null,
    is_active: true,
    is_targeted: false,
    target_date: null,
    activation_date: '2026-03-18T08:00:00',
    created_at: '2026-03-18T07:55:00',
    updated_at: '2026-03-20T10:30:00',
    tags: ['bitcoin', 'breakout'],
    clap_count: 142,
    trader: MOCK_TRADER,
  },
  {
    id: 'setup-2',
    category: 'futures',
    status: 'active',
    coin_name: 'ETHUSDT',
    coin_icon: 'https://assets.coingecko.com/coins/images/279/thumb/ethereum.png',
    order_type: 'market',
    position: 'short',
    duration: 'short',
    r_value: 0.75,
    entry_value: 3420,
    stop_value: 3550,
    profit_taking_1: 3200,
    profit_taking_amount_1: 60,
    profit_taking_2: 3000,
    profit_taking_amount_2: 40,
    profit_taking_3: null,
    profit_taking_amount_3: null,
    is_tp1: false,
    is_tp2: false,
    is_tp3: null,
    tp1_date: null,
    tp2_date: null,
    tp3_date: null,
    close_price: null,
    close_date: null,
    image: null,
    is_active: true,
    is_targeted: false,
    target_date: null,
    activation_date: '2026-03-21T14:00:00',
    created_at: '2026-03-21T13:50:00',
    updated_at: '2026-03-21T14:00:00',
    tags: ['ethereum', 'short'],
    clap_count: 87,
    trader: MOCK_TRADER,
  },
  {
    id: 'setup-3',
    category: 'spot',
    status: 'success',
    coin_name: 'SOLUSDT',
    coin_icon: 'https://assets.coingecko.com/coins/images/4128/thumb/solana.png',
    order_type: 'limit',
    position: null,
    duration: 'mid',
    r_value: 8,
    entry_value: 148,
    stop_value: 130,
    profit_taking_1: 175,
    profit_taking_amount_1: 50,
    profit_taking_2: 200,
    profit_taking_amount_2: 50,
    profit_taking_3: null,
    profit_taking_amount_3: null,
    is_tp1: true,
    is_tp2: true,
    is_tp3: null,
    tp1_date: new Date('2026-03-10T09:00:00'),
    tp2_date: new Date('2026-03-15T11:30:00'),
    tp3_date: null,
    close_price: 200,
    close_date: new Date('2026-03-15T11:30:00'),
    image: null,
    is_active: false,
    is_targeted: false,
    target_date: null,
    activation_date: '2026-03-05T10:00:00',
    created_at: '2026-03-05T09:55:00',
    updated_at: '2026-03-15T11:30:00',
    tags: ['solana', 'spot'],
    clap_count: 221,
    trader: MOCK_TRADER,
  },
  {
    id: 'setup-4',
    category: 'futures',
    status: 'stopped',
    coin_name: 'BNBUSDT',
    coin_icon: 'https://assets.coingecko.com/coins/images/825/thumb/bnb-icon2_2x.png',
    order_type: 'limit',
    position: 'long',
    duration: 'short',
    r_value: 1.25,
    entry_value: 580,
    stop_value: 560,
    profit_taking_1: 610,
    profit_taking_amount_1: 100,
    profit_taking_2: null,
    profit_taking_amount_2: null,
    profit_taking_3: null,
    profit_taking_amount_3: null,
    is_tp1: false,
    is_tp2: null,
    is_tp3: null,
    tp1_date: null,
    tp2_date: null,
    tp3_date: null,
    close_price: 558,
    close_date: new Date('2026-03-19T16:00:00'),
    image: null,
    is_active: false,
    is_targeted: false,
    target_date: null,
    activation_date: '2026-03-17T10:00:00',
    created_at: '2026-03-17T09:50:00',
    updated_at: '2026-03-19T16:00:00',
    tags: ['bnb'],
    clap_count: 34,
    trader: MOCK_TRADER,
  },
  {
    id: 'setup-5',
    category: 'spot',
    status: 'incoming',
    coin_name: 'SUIUSDT',
    coin_icon: 'https://assets.coingecko.com/coins/images/26375/thumb/sui_asset.jpeg',
    order_type: 'limit',
    position: null,
    duration: 'long',
    r_value: 6,
    entry_value: 3.12,
    stop_value: 2.7,
    profit_taking_1: 4.0,
    profit_taking_amount_1: 40,
    profit_taking_2: 5.5,
    profit_taking_amount_2: 35,
    profit_taking_3: 8.0,
    profit_taking_amount_3: 25,
    is_tp1: false,
    is_tp2: false,
    is_tp3: false,
    tp1_date: null,
    tp2_date: null,
    tp3_date: null,
    close_price: null,
    close_date: null,
    image: null,
    is_active: false,
    is_targeted: false,
    target_date: null,
    activation_date: null,
    created_at: '2026-03-22T18:00:00',
    updated_at: '2026-03-22T18:00:00',
    tags: ['sui', 'altcoin'],
    clap_count: 58,
    trader: MOCK_TRADER,
  },
  {
    id: 'setup-6',
    category: 'futures',
    status: 'active',
    coin_name: 'AVAXUSDT',
    coin_icon:
      'https://assets.coingecko.com/coins/images/12559/thumb/Avalanche_Circle_RedWhite_Trans.png',
    order_type: 'market',
    position: 'long',
    duration: 'short',
    r_value: 0.5,
    entry_value: 36.5,
    stop_value: 33.0,
    profit_taking_1: 42.0,
    profit_taking_amount_1: 60,
    profit_taking_2: 48.0,
    profit_taking_amount_2: 40,
    profit_taking_3: null,
    profit_taking_amount_3: null,
    is_tp1: false,
    is_tp2: false,
    is_tp3: null,
    tp1_date: null,
    tp2_date: null,
    tp3_date: null,
    close_price: null,
    close_date: null,
    image: null,
    is_active: true,
    is_targeted: false,
    target_date: null,
    activation_date: '2026-03-23T06:00:00',
    created_at: '2026-03-23T05:55:00',
    updated_at: '2026-03-23T06:00:00',
    tags: ['avax'],
    clap_count: 19,
    trader: MOCK_TRADER,
  },
]

const MOCK_STORAGE_KEY = 'mock_setups'

function loadMockSetups(): SetupModelPaginated['data'] {
  try {
    const saved = localStorage.getItem(MOCK_STORAGE_KEY)
    if (saved) return JSON.parse(saved) as SetupModelPaginated['data']
  } catch {}
  return [...MOCK_SETUPS_SEED]
}

function saveMockSetups() {
  try {
    localStorage.setItem(MOCK_STORAGE_KEY, JSON.stringify(MOCK_SETUPS))
  } catch {}
}

const MOCK_SETUPS: SetupModelPaginated['data'] = loadMockSetups()

const MOCK_COINS: CoinListModel['data'] = [
  {
    id: 'btc',
    code: 'BTCUSDT',
    code_name: 'Bitcoin',
    image: 'https://assets.coingecko.com/coins/images/1/thumb/bitcoin.png',
  },
  {
    id: 'eth',
    code: 'ETHUSDT',
    code_name: 'Ethereum',
    image: 'https://assets.coingecko.com/coins/images/279/thumb/ethereum.png',
  },
  {
    id: 'sol',
    code: 'SOLUSDT',
    code_name: 'Solana',
    image: 'https://assets.coingecko.com/coins/images/4128/thumb/solana.png',
  },
  {
    id: 'bnb',
    code: 'BNBUSDT',
    code_name: 'BNB',
    image: 'https://assets.coingecko.com/coins/images/825/thumb/bnb-icon2_2x.png',
  },
  {
    id: 'xrp',
    code: 'XRPUSDT',
    code_name: 'XRP',
    image: 'https://assets.coingecko.com/coins/images/44/thumb/xrp-symbol-white-128.png',
  },
  {
    id: 'ada',
    code: 'ADAUSDT',
    code_name: 'Cardano',
    image: 'https://assets.coingecko.com/coins/images/975/thumb/cardano.png',
  },
  {
    id: 'avax',
    code: 'AVAXUSDT',
    code_name: 'Avalanche',
    image:
      'https://assets.coingecko.com/coins/images/12559/thumb/Avalanche_Circle_RedWhite_Trans.png',
  },
  {
    id: 'dot',
    code: 'DOTUSDT',
    code_name: 'Polkadot',
    image: 'https://assets.coingecko.com/coins/images/12171/thumb/polkadot.png',
  },
  {
    id: 'link',
    code: 'LINKUSDT',
    code_name: 'Chainlink',
    image: 'https://assets.coingecko.com/coins/images/877/thumb/chainlink-new-logo.png',
  },
  {
    id: 'sui',
    code: 'SUIUSDT',
    code_name: 'SUI',
    image: 'https://assets.coingecko.com/coins/images/26375/thumb/sui_asset.jpeg',
  },
  {
    id: 'matic',
    code: 'MATICUSDT',
    code_name: 'Polygon',
    image: 'https://assets.coingecko.com/coins/images/4713/thumb/matic-token-icon.png',
  },
  {
    id: 'atom',
    code: 'ATOMUSDT',
    code_name: 'Cosmos',
    image: 'https://assets.coingecko.com/coins/images/1481/thumb/cosmos_hub.png',
  },
  {
    id: 'near',
    code: 'NEARUSDT',
    code_name: 'NEAR',
    image: 'https://assets.coingecko.com/coins/images/10365/thumb/near.jpg',
  },
  {
    id: 'op',
    code: 'OPUSDT',
    code_name: 'Optimism',
    image: 'https://assets.coingecko.com/coins/images/25244/thumb/Optimism.png',
  },
  {
    id: 'arb',
    code: 'ARBUSDT',
    code_name: 'Arbitrum',
    image: 'https://assets.coingecko.com/coins/images/16547/thumb/photo_2023-03-29_21.47.00.jpeg',
  },
]

export type SortOpts = 'newest' | 'oldest' | 'popular' | 'success' | 'fail'

export const GET_SETUP_LIST_PAGINATED_URL = `${API_URL}/setup/trader`
export const GET_SETUP_LIST_URL = `${API_URL}/setup/trader/`
export const COIN_LIST_URL = `${API_URL}/coin/`
export const TAG_LIST_URL = `${API_URL}/setup/tags/`
export const DELETE_SETUP_URL = `${API_URL}/setup/`
export const CRUD_SETUP_URL = `${API_URL}/setup/`

export const setupListPaginated = async (id: string | undefined, page = 0, pageSize = 100) => {
  return axios.get<SetupModelPaginated>(`${GET_SETUP_LIST_PAGINATED_URL}${id}`, {
    params: {
      skip: page,
      limit: pageSize,
      order_by: 'popular',
    },
  })
}

export const setupList = async ({
  userId,
  order_by = 'newest',
  skip = 0,
  limit = 100,
  config,
}: {
  userId?: string
  limit?: string | number
  skip?: string | number
  order_by?: SortOpts
  config?: AxiosRequestConfig<never>
}) => {
  if (MOCK_AUTH) {
    const numLimit = Number(limit)
    const numSkip = Number(skip)
    const sliced = MOCK_SETUPS.slice(numSkip, numSkip + numLimit)
    return {
      data: {
        total_count: MOCK_SETUPS.length,
        start: numSkip,
        limit: numLimit,
        data: sliced,
      } as SetupModelPaginated,
    }
  }

  return axios.get<SetupModelPaginated>(apiURL('/setup/trader', userId), {
    params: {
      limit,
      order_by,
      skip,
      ...(config as any)?._extraParams,
    },
    ...config,
  })
}

export const getSetup = async (setupId: string) => {
  if (MOCK_AUTH) {
    const found = MOCK_SETUPS.find((s) => s.id === setupId)
    return {status: 200, data: found ?? null}
  }
  return axios.get(apiURL('/setup', setupId))
}

export const tagList = async (config: AxiosRequestConfig) => {
  return axios.get<{
    data: string[]
  }>(TAG_LIST_URL, {
    params: {
      skip: 0,
      limit: 100,
    },
    ...config,
  })
}

export const createSetup = async (formBody: FormData, token: string) => {
  if (MOCK_AUTH) {
    const raw = formBody.get('item_in')
    if (raw) {
      const fields = JSON.parse(raw as string)
      const isMarket = fields.order_type === 'market'
      const coinEntry = MOCK_COINS.find((c) => c.code === fields.coin_name)
      const newSetup: SetupModelPaginated['data'][number] = {
        id: `mock-${Date.now()}`,
        category: fields.category ?? 'futures',
        status: isMarket ? 'active' : 'incoming',
        coin_name: fields.coin_name ?? '',
        coin_icon: coinEntry?.image ?? '',
        order_type: fields.order_type ?? 'limit',
        position: fields.position ?? 'long',
        duration: fields.duration ?? 'short',
        r_value: fields.r_value ?? 1,
        entry_value: isMarket
          ? fields.currentCoinPrice
            ? Number(fields.currentCoinPrice)
            : null
          : fields.entry_value ?? null,
        stop_value: fields.stop_value ?? null,
        profit_taking_1: fields.profit_taking_1 ?? null,
        profit_taking_amount_1: fields.profit_taking_amount_1 ?? null,
        profit_taking_2: fields.profit_taking_2 ?? null,
        profit_taking_amount_2: fields.profit_taking_amount_2 ?? null,
        profit_taking_3: fields.profit_taking_3 ?? null,
        profit_taking_amount_3: fields.profit_taking_amount_3 ?? null,
        is_tp1: false,
        is_tp2: null,
        is_tp3: null,
        tp1_date: null,
        tp2_date: null,
        tp3_date: null,
        close_price: null,
        close_date: null,
        image: null,
        is_active: isMarket,
        is_targeted: false,
        target_date: null,
        activation_date: isMarket ? new Date().toISOString() : null,
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString(),
        tags: fields.tags ?? [],
        clap_count: 0,
        trader: MOCK_TRADER,
      }
      MOCK_SETUPS.unshift(newSetup)
      saveMockSetups()
    }
    return {status: 200, data: {}}
  }
  return axios.put(apiURL('/setup/'), formBody, {
    headers: {
      accept: 'application/json',
      'Content-Type': 'multipart/form-data',
      Authorization: token,
    },
  })
}

export const updateSetup = async (id: string, formBody: FormData) => {
  if (MOCK_AUTH) {
    const raw = formBody.get('item_in')
    if (raw) {
      const patch = JSON.parse(raw as string)
      const idx = MOCK_SETUPS.findIndex((s) => s.id === id)
      if (idx !== -1) {
        MOCK_SETUPS[idx] = {...MOCK_SETUPS[idx], ...patch, updated_at: new Date().toISOString()}
        saveMockSetups()
      }
    }
    return {status: 200, data: {}}
  }
  return axios.patch(apiURL('/setup', id), formBody, {
    headers: {accept: 'application/json', 'Content-Type': 'multipart/form-data'},
  })
}

export const deleteSetup = async (id: string, config?: AxiosRequestConfig) =>
  axios.delete(apiURL('/setup', String(id)), config)

export const coinList = async (marketType: string, config: AxiosRequestConfig<never> = {}) => {
  if (MOCK_AUTH) {
    return {
      status: 200,
      data: {
        total_count: MOCK_COINS.length,
        start: 0,
        limit: 1000,
        data: MOCK_COINS,
      } as CoinListModel,
    }
  }

  return axios.get<CoinListModel>(apiURL('/coin/'), {
    params: {
      market_type: marketType,
      skip: 0,
      limit: 1000,
    },
    ...config,
  })
}
export const closeSetup = async (id: string) => {
  if (MOCK_AUTH) {
    const idx = MOCK_SETUPS.findIndex((s) => s.id === id)
    if (idx !== -1) {
      MOCK_SETUPS[idx] = {
        ...MOCK_SETUPS[idx],
        status: 'success',
        is_active: false,
        remaining_size_pct: 0,
        close_date: new Date(),
        updated_at: new Date().toISOString(),
      }
      saveMockSetups()
    }
    return {status: 200, data: {}}
  }
  return axios.patch(apiURL('/setup', id, 'close'), {
    headers: {accept: 'application/json'},
  })
}

/** OKX-style: close `percent` of remaining size at market. 100 = full close. */
export const partialCloseSetup = async (id: string, percent: number) => {
  const pct = Math.max(1, Math.min(100, Math.round(percent)))
  // Full close stays on the existing /close path. Partials hit /partial-close.
  if (pct >= 100) return closeSetup(id)
  if (MOCK_AUTH) {
    const idx = MOCK_SETUPS.findIndex((s) => s.id === id)
    if (idx !== -1) {
      const remaining = MOCK_SETUPS[idx].remaining_size_pct ?? 100
      const closed = (remaining * pct) / 100
      const next = Math.max(0, Math.round((remaining - closed) * 10) / 10)
      MOCK_SETUPS[idx] = {
        ...MOCK_SETUPS[idx],
        remaining_size_pct: next,
        ...(next <= 0
          ? {
              status: 'success' as const,
              is_active: false,
              close_date: new Date(),
            }
          : {}),
        updated_at: new Date().toISOString(),
      }
      saveMockSetups()
    }
    return {status: 200, data: {}}
  }
  return axios.patch(
    apiURL('/setup', id, 'partial-close'),
    {percent: pct},
    {headers: {accept: 'application/json'}}
  )
}

export type BanStatusResponse = {
  banned: boolean
  rule_type: 'daily_r_limit' | 'weekly_r_limit' | 'monthly_r_limit' | null
  reason: string | null
  banned_until: string | null
  daily_r: number
  weekly_r: number
  monthly_r: number
  limits: {daily: number; weekly: number; monthly: number}
}

// Backend-authoritative trading ban. Replaces the client-side R computation
// (riskUtils.getRiskBlock) which summed planned r_value per setup and produced
// false monthly bans for traders whose realized net R was fine (2026-07-12,
// KriptoKeman: real net R -4.02 but client math crossed -10).
export const getBanStatus = async (): Promise<{data: BanStatusResponse}> => {
  if (MOCK_AUTH) {
    return {
      data: {
        banned: false,
        rule_type: null,
        reason: null,
        banned_until: null,
        daily_r: 0,
        weekly_r: 0,
        monthly_r: 0,
        limits: {daily: -3, weekly: -7.5, monthly: -10},
      },
    }
  }
  const res = await axios.get(apiURL('/trader-rules', 'ban-status'))
  return {data: res.data as BanStatusResponse}
}

export const checkSetupPosition = async (id: string) => {
  if (MOCK_AUTH) {
    return {status: 200, data: {data: {events: []}}}
  }
  return axios.get(apiURL('/setup', id, 'check-position'), {params: {simulate: true}})
}

// Non-simulation run: the checker persists the corrected state (is_tpN, status, dates)
// to the setup, then returns the same event stream.
export const applyCheckSetupPosition = async (id: string) => {
  if (MOCK_AUTH) {
    return {status: 200, data: {data: {events: []}}}
  }
  return axios.get(apiURL('/setup', id, 'check-position'), {params: {simulate: false}})
}
